module.exports = __webpack_public_path__ + "img/footer-bg.287ee2d9.png";